export const createUtagViewData = (
    application_name,
    application_module,
    application_partner,
    page_pathname,
    page_title,
    scenario_name,
    scenario_step
) => {
    return {
        application_name: application_name,
        application_module: application_module,
        application_partner: application_partner,
        page_pathname: page_pathname,
        page_title: page_title,
        scenario_name: scenario_name,
        scenario_step: scenario_step
    };
};

export const createPurchaseData = (
    application_name,
    application_partner,
    order_id,
    order_total,
    page_pathname,
    page_title,
    product_sku,
    product_name,
    product_quantity,
    product_unit_price,
    scenario_name,
    scenario_step,
    scenario_conversion
) => {
    return {
        event_name: 'purchase',
        application_name: application_name,
        application_partner: application_partner,
        order_id: order_id,
        order_total: order_total,
        page_pathname: page_pathname,
        page_title: page_title,
        product_sku: product_sku,
        product_name: product_name,
        product_quantity: product_quantity,
        product_unit_price: product_unit_price,
        scenario_name: scenario_name,
        scenario_step: scenario_step,
        scenario_conversion: scenario_conversion
    };
};

export const invokeUtagData = data => {
    //@ts-ignore
    window.utag.view(data);
};

export const invokeFbq = product => {
    //@ts-ignore
    window.fbq('trackCustom', product);
};

export const invokeFbqPurchase = (product, price) => {
    //@ts-ignore
    window.fbq('trackCustom', product + '-Purchase', {
        value: price,
        currency: 'SEK'
    });
};

export const invokeUtagLink = zipCode => {
    //@ts-ignore
    window.utag.link({
        event_category: 'zipcode',
        event_action: 'submit',
        event_label: 'zipcode',
        customer_zip: [zipCode]
    });
};
